import { PageDataFragmentGql } from '@haaretz/s-fragments/PageData';
import { StepDataFragmentGql } from '@haaretz/s-fragments/StepData';
import { HtmlNodeFragmentGql } from '@haaretz/s-fragments/HTMLNode';
import { PurchaseToggleKickerFragmentGql } from '@haaretz/s-fragments/PurchaseToggleKicker';
import { PurchaseOfferFragmentGql } from '@haaretz/s-fragments/PurchaseOffer';
import { MarketingBulletFragmentGql } from '@haaretz/s-fragments/MarketingBullet';
import { SpecialSaleDataFragmentGql } from '@haaretz/s-fragments/SpecialSaleData';
import { ImageFragmentGql } from '@haaretz/s-fragments/HTZ_image_Image';
import { ImageCropFragmentGql } from '@haaretz/s-fragments/ImageCrop';
import { CartDataFragmentGql } from '@haaretz/s-fragments/CartData';
import { SelectedOfferFragmentGql } from '@haaretz/s-fragments/SelectedOffer';
import { AbTestDataFragmentGql } from '@haaretz/s-fragments/AbTestData';
import { CounterFragmentGql } from '@haaretz/s-fragments/Counter';
import { useQuery, useInfiniteQuery } from '@tanstack/react-query';
import { fetch } from '@haaretz/s-graphql-fetcher';
export const PurchasePagePersonalQueryDocument = `
    query PurchasePagePersonalQuery($couponId: String, $pathSegment: String, $selectedOfferId: String, $ticketId: String, $userId: String, $cartData: Boolean, $previousSteps: String, $flow: String, $countryCode: String, $currency: String) {
  PurchasePage(
    couponId: $couponId
    pathSegment: $pathSegment
    selectedOfferId: $selectedOfferId
    ticketId: $ticketId
    userId: $userId
    cartData: $cartData
    previousSteps: $previousSteps
    flow: $flow
    countryCode: $countryCode
    currency: $currency
  ) {
    pageData {
      ...PageDataFragment
    }
  }
}
    ${PageDataFragmentGql}
${StepDataFragmentGql}
${HtmlNodeFragmentGql}
${PurchaseToggleKickerFragmentGql}
${PurchaseOfferFragmentGql}
${MarketingBulletFragmentGql}
${SpecialSaleDataFragmentGql}
${ImageFragmentGql}
${ImageCropFragmentGql}
${CartDataFragmentGql}
${SelectedOfferFragmentGql}
${AbTestDataFragmentGql}
${CounterFragmentGql}`;
export const usePurchasePagePersonalQuery = (variables, options)=>useQuery(variables === undefined ? [
        'PurchasePagePersonalQuery'
    ] : [
        'PurchasePagePersonalQuery',
        variables
    ], fetch(PurchasePagePersonalQueryDocument, variables), options);
usePurchasePagePersonalQuery.document = PurchasePagePersonalQueryDocument;
usePurchasePagePersonalQuery.getKey = (variables)=>variables === undefined ? [
        'PurchasePagePersonalQuery'
    ] : [
        'PurchasePagePersonalQuery',
        variables
    ];
export const useInfinitePurchasePagePersonalQuery = (pageParamKey, variables, options)=>{
    return useInfiniteQuery(variables === undefined ? [
        'PurchasePagePersonalQuery.infinite'
    ] : [
        'PurchasePagePersonalQuery.infinite',
        variables
    ], (metaData)=>fetch(PurchasePagePersonalQueryDocument, {
            ...variables,
            ...metaData.pageParam ?? {}
        })(metaData), options);
};
useInfinitePurchasePagePersonalQuery.getKey = (variables)=>variables === undefined ? [
        'PurchasePagePersonalQuery.infinite'
    ] : [
        'PurchasePagePersonalQuery.infinite',
        variables
    ];
usePurchasePagePersonalQuery.fetcher = (variables, options)=>fetch(PurchasePagePersonalQueryDocument, variables, options);

//# sourceMappingURL=PurchasePage.js.map